import { store } from '../../store'
import { plainToClass } from 'class-transformer'
import { GetCourseDTO } from '../../dto/courses'
import { validate } from 'class-validator'

export const getCourse = async ( id: number ) => {

    let body, response

    try {

        response = await fetch( `${ process.env.REACT_APP_API_ORIGIN }/1.0.0/cms/courses/${ id }`, {
            headers: {
                'Authorization': 'Bearer ' + store.getState().session.token,
                'Content-Type': 'application/json'
            },
            method: 'GET'
        } )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_COURSE_TIMEOUT' } )
        return

    }

    if ( response.status === 401 ) {

        store.dispatch( { type: 'GET_COURSE_UNAUTHORIZED' } )
        return

    }

    if ( response.status !== 200 ) {

        store.dispatch( { type: 'GET_COURSE_UNEXPECTEDRESPONSE' } )
        return

    }

    try {

        body = plainToClass( GetCourseDTO, JSON.parse( await response.text() ) )

    } catch ( exception ) {

        store.dispatch( { type: 'GET_COURSE_INVALIDJSON' } )
        return

    }

    if ( ( await validate( body ) ).length > 0 ) {

        store.dispatch( { type: 'GET_COURSE_INVALIDRESPONSE' } )
        return

    }

    store.dispatch( { type: 'GET_COURSE_OK', course: body.course } )

}